import GModalHeader from "../../g-modal/header";
import GModalBody from "../../g-modal/body";
import GModalFooter from "../../g-modal/footer";
import MarkdownToHtml from "glesys-controlpanel/components/markdown-to-html";
import GButton from "../../g-button";
import { on } from "@ember/modifier";
import modalClose from "glesys-controlpanel/helpers/modal-close";
import { t } from "ember-intl";
import styles from "./styles.module.css";

<template>
  <GModalHeader data-test-modals-help-topic-header>
    {{@params.topic.title}}
  </GModalHeader>
  <GModalBody>
    <div class="{{styles.root}}" data-test-modals-help-topic-content>
      <MarkdownToHtml @markdown={{@params.topic.body}} />
    </div>
  </GModalBody>
  <GModalFooter>
    <GButton @color="gray" {{on "click" (modalClose)}}>
      {{t "button.close"}}
    </GButton>
  </GModalFooter>
</template>
